import axios from "./config";

/**
 * @function
 * @name getUsers
 * @description get Users with optional filters
 * */
const getUsers = (params={}) => {
    const queryParams = { 
        page: params.page, 
        per_page: params.per_page || 10, 
        searchField: params.searchField || 'first_name', 
        searchQuery: params.searchQuery,
        invite_status: params.invite_status,
        project_id: params.project_id,
        council_id: params.council_id
    };
    
    // Remove undefined values
    Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === undefined || queryParams[key] === '') {
            delete queryParams[key];
        }
    });
    
    return axios.get(`/users`, { params: queryParams }).then((response) => response.data);
}
    

/**
 * create new User
 *
 * @function
 * @name createUser
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const createUsers = (user) => axios.post(`/users`, user ).then((response) => response.data);


/**
 * 
 * Edit user from the API
 * @function
 * @name editUser
 * @param {Object} id - Id of user
 * @returns {Promise}
 *
 * @version 0.1.0
 * @since 0.1.0
 */
 const editUser = (user, id) => {
    return axios
        .patch(`/users/${id}`, user)
        .then((response) => response.data);
};

/**
 * @function
 * @name getAuthUser
 * @description gets authenticated user
 * @returns {Promise}
 *
 * @version 0.1.0
 * @since 0.1.0
 */
 const getAuthUser = () => axios.get(`/users/auth_user`)
 .then((response) => {
     return response.data;
 });


/**
 * detaches a User from list
 *
 * @function
 * @name deleteUser
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const deleteUser = (User) => {
    return axios
        .delete(`users/${User}`)
        .then((response) => response.data);
};

/**
 * @function
 * @name resendInvite
 * @description resend invitation to user
 * @param {number} userId - The user ID
 * @returns {Promise}
 */
const resendInvite = (userId) => {
    return axios.post(`/users/${userId}/resend-invite`).then((response) => response.data);
};

/**
 * @function
 * @name getInvitationDetails
 * @description get invitation details by token
 * @param {string} token - The invitation token
 * @returns {Promise}
 */
const getInvitationDetails = (token) => {
    return axios.get(`/invitations/${token}`).then((response) => response.data);
};

/**
 * @function
 * @name acceptInvitation
 * @description accept invitation and set password
 * @param {Object} data - Contains token, password, password_confirmation
 * @returns {Promise}
 */
const acceptInvitation = (data) => {
    return axios.post('/invitations/accept', data).then((response) => response.data);
};

export default {
    getUsers,
    getAuthUser,
    createUsers,
    editUser,
    deleteUser,
    resendInvite,
    getInvitationDetails,
    acceptInvitation,
}
